<template>
  <div>
    <Tags
      class="mt-3"
      :compact="true"
      :record="record"
    />

    <p v-if="getCurrentProcessType !== 'private'">
      {{ $t('processes.sidebar.tags_description') }}
    </p>
  </div>
</template>

<script>
import Tags from '@/components/Tags.vue'
import { mapGetters } from 'vuex'

export default {
  components: {
    Tags,
  },
  props: {
    record: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapGetters('processes', ['getCurrentProcessType']),
  }
}
</script>

<style>

</style>
